var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInAppMessaging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0215,
    r: 24,
    fill: "#FFE3CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_3121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68859 17.5458C9.77108 12.3087 13.1018 9.39189 18.2971 8.51073C22.1376 7.85949 25.9796 7.85124 29.8137 8.52902C35.163 9.47458 38.3788 12.5615 39.4033 17.8777C40.1948 21.9863 40.2072 26.1386 39.3908 30.2433C38.2957 35.4441 34.8791 38.6544 29.7029 39.5323C25.8624 40.1835 22.0204 40.1917 18.1863 39.514C12.837 38.5684 9.60692 35.3273 8.58254 30.0112C7.75068 25.8755 7.83072 21.6969 8.68859 17.5457V17.5458Z",
    fill: "#FD910C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9531 26.9509V19.8778H33.3586V26.8439C33.3586 28.6868 31.8697 30.1808 30.0332 30.1808H20.616L15.7548 34.0297L14.8842 32.9224L20.1154 28.7806L20.1256 28.7962V28.7704H30.1398C31.1413 28.7704 31.9531 27.9557 31.9531 26.9509ZM16.6404 17.1765C16.4828 17.1765 16.3317 17.2394 16.2202 17.3512C16.1087 17.463 16.0461 17.6147 16.0461 17.7729V29.105H14.6406V17.3258C14.6406 16.4644 15.3365 15.7661 16.1948 15.7661H33.3686L33.3484 17.1765H16.6404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_3121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8.02148)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAppMessaging);
export default __webpack_public_path__ + "static/media/inAppMessaging.c473ffbe.svg";
export { ForwardRef as ReactComponent };